// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__pfqrQ","overflowing":"ReadFullNote_overflowing__2-cD9"};